/**
 * Where a tapped push notification should open.
 * send-push-notification-v2 copies type, task_id, and project_id onto the payload.
 */

export const PUSH_OPEN_EVENT = 'pacarion-push-open';

function text(value) {
  if (value == null) return '';
  return String(value).trim();
}

export function pushDestination(data) {
  const payload = data && typeof data === 'object' ? data : {};
  const type = text(payload.type).toLowerCase();
  const taskId = text(payload.task_id || payload.taskId);
  const projectId = text(payload.project_id || payload.projectId);
  const clientId = text(payload.homeowner_id || payload.client_id || payload.clientId);
  let screen = '';
  if (type.includes('project') || (projectId && !taskId && !type.includes('task'))) {
    screen = 'projects';
  } else if (
    type.includes('task')
    || taskId
    || type === 'created'
    || type === 'assigned'
    || type === 'updated'
    || type === 'completed'
  ) {
    screen = 'tasks';
  } else if (projectId) {
    screen = 'projects';
  }
  return { screen, taskId, projectId, clientId };
}

export function publishPushOpen(data) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(PUSH_OPEN_EVENT, { detail: pushDestination(data) }));
}
